import socket from "./socket";

const logoutDriver = (driverId) => {
  if (driverId) {
    socket.emit("driver:logoutDriver", { driverId });
  }
};

export default logoutDriver;
